import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getConcentracionLiquidez, getDataPlazo, getDataProducto, getDataSaldo, getEvaluaciones, getPeriodosLiquidez, getPerspectivas, getPropieties, setLimites } from './query';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ConcentracionService {
  private readonly apiURL = environment.api_aleemaRiesgosGeneralRest;
  private readonly headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private headersRes = new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  constructor(
    private apollo: Apollo,    
    private readonly cookies: CookieService,
    private http: HttpClient,
  ) { }

  /**
   * Obtiene las evaluaciones disponibles para la plantilla de Alerta Temprana
   * @param idPlantilla ID de la plantilla
   * @returns Datos de evaluaciones
   */
  async getEvaluaciones(idPlantilla: number = 7) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getEvaluaciones,
        context: { headers: this.headers },
        variables: { idPlantilla }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene los datos de concentración por plazo
   * @param periodo Periodo en formato YYYY-MM
   * @returns Datos de AHO_12
   */
  async getDataPlazo(periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getDataPlazo,
        context: { headers: this.headers },
        variables: { periodo }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene los datos de concentración por producto
   * @param periodo Periodo en formato YYYY-MM
   * @returns Datos de AHO_13
   */
  async getDataProducto(periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getDataProducto,
        context: { headers: this.headers },
        variables: { periodo }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene los datos de concentración por saldo
   * @param periodo Periodo en formato YYYY-MM
   * @returns Datos de AHO_11
   */
  async getDataSaldo(periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getDataSaldo,
        context: { headers: this.headers },
        variables: { periodo }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene las propiedades de ahorros para un periodo específico
   * @param institucionId ID de la institución
   * @param periodo Periodo en formato YYYY-MM
   * @returns Propiedades y límites de ahorros
   */
  async getPropiedades(institucionId: string, periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getPropieties,
        context: { headers: this.headers },
        variables: { institucionId, periodo }
      }).valueChanges
    );
    return data;
  }

  /**
   * Establece o actualiza los límites de concentración
   * @param periodo Periodo en formato YYYY-MM
   * @param propiedades Objeto JSON con las propiedades y límites
   * @param institucionId ID de la institución
   * @returns Resultado de la mutación
   */
  async setLimites(periodo: string, propiedades: any, institucionId: string) {
    const result = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).mutate({
        mutation: setLimites,
        context: { headers: this.headers },
        variables: {
          periodo,
          propiedades,
          institucionId
        }
      })
    );
    return result;
  }

  async getPerspectivasLiquidez(){
    const result = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).mutate({
        mutation: getPerspectivas,
        context: { headers: this.headers },
        variables: {}
      })
    );
    return result.data['liquidezPerspectives'];
  }
  /**
   * consulta los periodos del backend de riesgos general 
   * @param idInstitucion id del administrador
   * @returns 
   */
  async getPeriodosRiesgos(idInstitucion: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
        query: getPeriodosLiquidez,
        context: { headers: this.headers },
        variables: { idInstitucion }
      }).valueChanges
    );
    return data.getPeriodsLiquidezSubcalculation;
  }
  /**
   * consulta subcalculos de concentracion liquidez 
   * @param idInstitucion id del administrador
   * @param anio 
   * @param mes 
   * @returns 
   */
  async getConcentracionLiquidez(idInstitucion: string, anio: number, mes: number) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
        query: getConcentracionLiquidez,
        context: { headers: this.headers },
        variables: { idInstitucion, anio, mes }
      }).valueChanges
    );
    return data.getConcentracionLiquidez;
  }
}